import React from 'react';
import './ServiceBanner.scss';
import serviceBanner from '../../assets/emergency.png';

const ServiceBanner = () => {
    return (
        <section className='service-banner-section section-common section-bg'>
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-5 col-md-6">
                                <div className="service-banner-text">
                                    <h2>Dental Plans</h2>
                                    <p>Choose from our comprehensive dental plans designed for families, students, and individuals. Get the best dental care at affordable prices with our special offers and discounts.</p>
                                    
                                    <div className="plan-highlights">
                                        <div className="plan-item">
                                            <span className="plan-icon">👨‍👩‍👧</span>
                                            <div className="plan-text">
                                                <h4>Smile Card (Family Plan)</h4>
                                                <p>₹499/year for 4 members - Most Popular</p>
                                            </div>
                                        </div>
                                        <div className="plan-item">
                                            <span className="plan-icon">🎓</span>
                                            <div className="plan-text">
                                                <h4>Student Dental Health Card</h4>
                                                <p>₹99/student with parent discounts - Best Value</p>
                                            </div>
                                        </div>
                                        <div className="plan-item">
                                            <span className="plan-icon">🆓</span>
                                            <div className="plan-text">
                                                <h4>Free Dental Check-Up</h4>
                                                <p>FREE for everyone - Limited Time Offer</p>
                                            </div>
                                        </div>
                                        <div className="plan-item">
                                            <span className="plan-icon">💰</span>
                                            <div className="plan-text">
                                                <h4>15% OFF All Treatments</h4>
                                                <p>15% discount on all procedures - Special Offer</p>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="theme-btn">
                                        <a href="tel:6395947006" className="call-now-btn">
                                            <span className="call-icon">📞</span>
                                            Call Now: 6395947006
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-6">
                                <div className="service-banner-img">
                                    <img src={serviceBanner} alt="service" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceBanner;